import React, { useState } from 'react'
import { IconButton, TableCell, TableRow } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import { useNavigate } from 'react-router-dom'
import Delete from './Delete'

const Row = ({ data, refetch }) => {
  const [openDelete, setOpenDelete] = useState(false)
  const navigate = useNavigate()

  return (
    <>
      <TableRow>
        <TableCell>{data.htgCompany}</TableCell>
        <TableCell>{data.companyAccountId}</TableCell>
        <TableCell>{data.companyName}</TableCell>
        <TableCell>
          <IconButton
            color='info'
            onClick={() => navigate(`/map/transaction/${data.id}`)}
            size='small'
          >
            <ReceiptLongIcon />
          </IconButton>
          <IconButton color='primary' onClick={() => navigate(`/map/${data.id}`)} size='small'>
            <EditIcon />
          </IconButton>
          <IconButton color='error' onClick={() => setOpenDelete(true)} size='small'>
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
      <Delete
        data={data}
        onClose={() => setOpenDelete(false)}
        openDelete={openDelete}
        refetch={refetch}
      />
    </>
  )
}

export default Row
